









import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const couponModule = namespace("coupon");

@Component
export default class SearchType extends Vue {
  mounted() {
    this.setActive();
  }
  setActive() {
    this.$store.commit("coupon/setcouponSearchStep", 0);
  }
  handleSearchClick(bool: boolean) {
    if (bool) {
      this.$router.push({ path: `/couponVerification/search` });
    } else {
      this.$router.push({ path: `/couponVerification/searchMember` });
    }
  }
}
